// Antifraude do checkout com cartão (presale) — sem atrito para o cliente.
//  - Turnstile (Cloudflare): só roda se REACT_APP_TURNSTILE_SITE_KEY estiver definida.
//  - Dados do dispositivo para o 3D Secure (o backend só os usa se o 3DS estiver ligado).

const TS_SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
const TOKEN_TTL_MS = 240000; // token vale 5 min e é de uso único; renova antes disso

let tsScriptPromise = null;

// Estado do último Turnstile no navegador: sem_chave | script_bloqueado | timeout | erro_widget | erro_render | ok
// Vai junto do pagamento (turnstile_client) para o backend distinguir falha técnica de rejeição real.
let tsStatus = 'nao_executado';
export function getTurnstileStatus() {
  return tsStatus;
}

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve();
  if (!tsScriptPromise) {
    tsScriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = TS_SCRIPT;
      s.async = true;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('turnstile_load_failed'));
      document.head.appendChild(s);
    });
  }
  return tsScriptPromise;
}

// Gera um token novo. Nunca rejeita (resolve null em qualquer falha).
// O widget fica FORA da tela, mas com tamanho real: no modo "Non-interactive" o Turnstile precisa renderizar
// para concluir o desafio — dentro de display:none ele nunca terminava (timeout).
function requestToken(timeoutMs) {
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  if (!siteKey) {
    tsStatus = 'sem_chave';
    return Promise.resolve(null);
  }
  tsStatus = 'nao_executado';

  return loadTurnstile()
    .then(
      () =>
        new Promise((resolve) => {
          const holder = document.createElement('div');
          holder.style.cssText =
            'position:fixed;left:-10000px;top:0;width:300px;height:65px;opacity:0;pointer-events:none;';
          holder.setAttribute('aria-hidden', 'true');
          document.body.appendChild(holder);
          let widgetId;
          const cleanup = () => {
            try {
              if (window.turnstile && widgetId !== undefined) window.turnstile.remove(widgetId);
            } catch (_) {}
            if (holder.parentNode) holder.parentNode.removeChild(holder);
          };
          const timer = setTimeout(() => { tsStatus = 'timeout'; cleanup(); resolve(null); }, timeoutMs);
          try {
            widgetId = window.turnstile.render(holder, {
              sitekey: siteKey,
              callback: (token) => { tsStatus = 'ok'; clearTimeout(timer); cleanup(); resolve(token); },
              'error-callback': () => { tsStatus = 'erro_widget'; clearTimeout(timer); cleanup(); resolve(null); },
            });
          } catch (_) {
            tsStatus = 'erro_render';
            clearTimeout(timer);
            cleanup();
            resolve(null);
          }
        }),
    )
    .catch(() => {
      tsStatus = 'script_bloqueado';
      return null;
    });
}

let prefetched = null; // { promise, at }

/** Começa a gerar o token antes do clique em pagar (ex.: ao abrir o pagamento), para ele estar pronto no envio. */
export function prefetchTurnstile(timeoutMs = 15000) {
  if (prefetched && Date.now() - prefetched.at < TOKEN_TTL_MS) return;
  prefetched = { at: Date.now(), promise: requestToken(timeoutMs) };
}

/**
 * Devolve o token do Turnstile ou null (sem chave configurada, bloqueio de script ou timeout).
 * Usa o token pré-gerado quando houver (uso único); senão gera na hora.
 * Nunca rejeita: o CAPTCHA não pode impedir uma compra legítima; quem decide é o backend.
 */
export function getTurnstileToken(timeoutMs = 15000) {
  if (prefetched && Date.now() - prefetched.at < TOKEN_TTL_MS) {
    const p = prefetched.promise;
    prefetched = null;
    return p.then((token) => token || requestToken(timeoutMs));
  }
  prefetched = null;
  return requestToken(timeoutMs);
}

/** Dados do dispositivo que o banco emissor usa para avaliar risco no 3DS. timeZoneOffset em HORAS. */
export function getDeviceInfo() {
  try {
    return {
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZoneOffset: new Date().getTimezoneOffset() / 60,
      language: navigator.language,
      userAgent: navigator.userAgent,
    };
  } catch (_) {
    return {};
  }
}
